import { Link } from 'react-router-dom';

const STATS = [
  { num: '15+', label: 'Years Experience', icon: 'ri-calendar-fill' },
  { num: '1,200+', label: 'Projects Completed', icon: 'ri-home-3-fill' },
  { num: '4.9★', label: 'Customer Rating', icon: 'ri-star-fill' },
  { num: '100%', label: 'Licensed & Insured', icon: 'ri-shield-check-fill' },
];

const REASONS = [
  {
    icon: 'ri-map-pin-2-fill',
    title: 'Local Utah Expertise',
    desc: 'We live and work here. Our team knows Utah weather patterns, local building codes, and roofing challenges better than any national chain.',
  },
  {
    icon: 'ri-eye-fill',
    title: 'Transparent Pricing',
    desc: 'Itemized estimates with zero hidden fees. You know every cost before we start. No surprises, no pressure tactics.',
  },
  {
    icon: 'ri-medal-2-fill',
    title: 'High-End Workmanship',
    desc: 'Manufacturer-certified crews. Best-practice installation. Every roof is built to outlast the warranty and perform in Utah\'s climate.',
  },
  {
    icon: 'ri-timer-flash-fill',
    title: 'Fast Project Timelines',
    desc: 'Most replacements complete in 1–3 days. We work full days and clean up completely — minimal disruption to your family.',
  },
  {
    icon: 'ri-file-shield-2-fill',
    title: 'Insurance Claim Guidance',
    desc: 'From claim filing to adjuster meetings, we navigate the entire process for you to maximize your insurance coverage.',
  },
  {
    icon: 'ri-customer-service-2-fill',
    title: 'Lifetime Support',
    desc: 'Our relationship extends beyond project completion. Warranty assistance, annual reminders, and ongoing support whenever you need us.',
  },
];

export default function WhyChooseUsSection() {
  return (
    <section id="why-us" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block w-16 h-1 bg-brand-orange rounded-full mb-6"></div>
          <h2 className="font-heading font-900 text-charcoal text-5xl md:text-6xl lg:text-7xl uppercase tracking-tight leading-none mb-4">
            Why Utah Chooses<br />
            <span className="text-brand-orange">IWC Roofing</span>
          </h2>
          <p className="font-body text-charcoal/60 text-lg max-w-2xl mx-auto">
            When your roof is on the line, trust the contractor that thousands of Utah homeowners and businesses rely on.
          </p>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
          {STATS.map((stat) => (
            <div key={stat.label} className="bg-charcoal rounded-xl p-6 text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-brand-orange/15 rounded-lg mx-auto mb-3">
                <i className={`${stat.icon} text-brand-orange text-2xl`}></i>
              </div>
              <div className="font-heading font-900 text-brand-orange text-4xl leading-none mb-1">{stat.num}</div>
              <div className="font-body text-white/50 text-xs uppercase tracking-widest">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {REASONS.map((r) => (
            <div key={r.title} className="bg-surface hover:bg-surface-dark transition-colors duration-200 rounded-xl p-7">
              <div className="w-12 h-12 flex items-center justify-center bg-brand-orange/10 rounded-lg mb-4">
                <i className={`${r.icon} text-brand-orange text-2xl`}></i>
              </div>
              <h3 className="font-heading font-800 text-charcoal text-xl uppercase tracking-wide mb-2">{r.title}</h3>
              <p className="font-body text-charcoal/60 text-sm leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/#estimate"
            className="inline-flex items-center gap-3 bg-brand-orange hover:bg-brand-orange-dark text-white font-heading font-700 text-lg uppercase tracking-widest px-10 py-4 rounded-md transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-fill text-xl"></i>
            Get Your Free Estimate
          </Link>
        </div>
      </div>
    </section>
  );
}
